// extracted by mini-css-extract-plugin
module.exports = {"messageItem":"CancelPopup_messageItem__1cOQY","messageListItem":"CancelPopup_messageListItem__HNxU5"};